// @flow
import { fork, all } from 'redux-saga/effects';

import { sagas as jwtSagas } from 'nozzmo-redux-jwt';
import * as api from '../api';

import {
  watchRedirectAfterLogin,
  watchLogout,
} from './login';
import {
  watchStudentFetch,
  watchAssignedStops,
  watchaddStudentParents,
  watchFetchStudentParents,
  watchFetchStudentChangeStopRequests,
  watchSaveAssignedStops,
  watchRemoveStudentParents,
  watchFetchStudentGateways,
  watchUpdateStudent,
} from './students';
import {
  watchRoutesFetch,
  watchRouteStopsFetch,
  watchCreateRoute,
  watchRouteDelete,
  watchSortStop,
  watchRoutesDirectionsFetch,
  watchRouteUpdate,
  watchRouteStopAdded,
  watchDeleteRouteStopStudent,
  watchRouteStopSelected,
  watchRouteStopStudentsFetchStarted,
  watchRouteStopUpdated,
  watchSchoolRoutesFetchStarted,
  watchRouteStopStudentAdded,
  watchRouteStopRemoved,
  watchFetchRouteStop,
  watchAssignStudentToStops,
} from './routes';
import {
  watchCurrentTripFetch,
  watchTripsSchoolFetch,
  watchCreateTrip,
  watchTakeTripAssistance,
  watchSingleTripFetchStarted,
  watchTripStopCompleted,
  watchTripCompletion,
  watchTripFetchStarted,
  watchFinishTrip,
} from './trips';
import {
  watchNotificationsFetch,
  watchReadNotification,
  watchNotificationsCount,
  watchSendNotifications,
  watchWatchAllNotifications,
  watchReadAllNotifications,
} from './notifications';
import {
  watchJoinChannelRequired,
} from './socket';
import {
  watchFetchReports,
} from './reports';
import {
  watchFetchChangeStopRequest,
  watchupdateStateChangeStopRequest,
  watchCreateChangeStopRequest,
  watchFetchChangeStopRequestCounter
} from './changeStopRequests';
import {
  watchAddUser,
  watchUsersFetch,
  watchRemoveUser,
  watchFetchUserCode,
  watchUploadUsers,
  watchUpdateUser,
} from './users';
import {
  watchMonitorFetch,
  watchFetchMonitorRoutes,
  watchAddMonitorRoutes,
  watchUpdateMonitor,
} from './monitors';
import {
  watchDriverFetch,
} from './drivers';
import {
  watchBusesFetch,
  watchCreateBus,
  watchFetchSchoolBuses,
  watchRemoveBus,
  watchUpdateBus,
  watchUpdateBusLastPosition,
  watchTimeUpdatedBusOffline,
} from './buses';

import {
  watchGatewaysFetch,
  watchGatewaysCreate,
  watchGatewaysUsersFetch,
  watchAddGatewayUsers,
  watchRemoveGatewayUsers,
  watchRemoveGateway,
  watchUpdateGatewayActions,
  watchUpdateGateway,
} from './gateways';

import {
  watchGatesFetch,
  watchGatesCreate,
  watchRemoveGate,
} from './gates';

import {
  watchNextTemporalBanner,
  watchNewTemporalBanner,
} from './temporalBanners';

import {
  watchStartTemporaryEvent,
} from './temporaryEvents';

import {
  watchUpdateParent,
  watchParentFetch,
  watchParentStudentsFetch,
} from './parents';


const extractToken = ({ token }) => token;
const getDecodedPayload = (decode, { token, user }) => ({
  ...decode(token),
  ...user,
});

const watchLogin = jwtSagas.genLoginSaga(
  api.login,
  extractToken,
  getDecodedPayload,
);

function* mainSaga(): Iterator<any> {
  yield all([
    fork(watchLogin),
    fork(watchRedirectAfterLogin),
    fork(watchLogout),
    fork(watchSendNotifications),
    fork(watchDeleteRouteStopStudent),
    fork(watchGatewaysFetch),
    fork(watchGatesFetch),
    fork(watchGatesCreate),
    fork(watchFetchReports),
    fork(watchRemoveGate),
    fork(watchSaveAssignedStops),
    fork(watchRouteUpdate),
    fork(watchAssignedStops),
    fork(watchSchoolRoutesFetchStarted),
    fork(watchStudentFetch),
    fork(watchFetchStudentChangeStopRequests),
    fork(watchFetchStudentParents),
    fork(watchupdateStateChangeStopRequest),
    fork(watchFetchChangeStopRequest),
    fork(watchCreateChangeStopRequest),
    fork(watchSortStop),
    fork(watchRouteDelete),
    fork(watchCreateRoute),
    fork(watchRoutesFetch),
    fork(watchRouteStopsFetch),
    fork(watchFetchMonitorRoutes),
    fork(watchFetchRouteStop),
    fork(watchRoutesDirectionsFetch),
    fork(watchTripsSchoolFetch),
    fork(watchCurrentTripFetch),
    fork(watchCreateTrip),
    fork(watchTakeTripAssistance),
    fork(watchTripStopCompleted),
    fork(watchTripCompletion),
    fork(watchNotificationsFetch),
    fork(watchReadNotification),
    fork(watchNotificationsCount),
    fork(watchWatchAllNotifications),
    fork(watchJoinChannelRequired),
    fork(watchReadAllNotifications),
    fork(watchRouteStopAdded),
    fork(watchRouteStopSelected),
    fork(watchRouteStopStudentsFetchStarted),
    fork(watchRouteStopUpdated),
    fork(watchRouteStopStudentAdded),
    fork(watchTripFetchStarted),
    fork(watchRouteStopRemoved),
    fork(watchAddUser),
    fork(watchUsersFetch),
    fork(watchRemoveUser),
    fork(watchUpdateUser),
    fork(watchUploadUsers),
    fork(watchMonitorFetch),
    fork(watchUpdateMonitor),
    fork(watchDriverFetch),
    fork(watchFetchUserCode),
    fork(watchFetchStudentGateways),
    fork(watchBusesFetch),
    fork(watchGatewaysCreate),
    fork(watchRemoveGateway),
    fork(watchGatewaysUsersFetch),
    fork(watchAddGatewayUsers),
    fork(watchRemoveGatewayUsers),
    fork(watchUpdateGatewayActions),
    fork(watchUpdateGateway),
    fork(watchCreateBus),
    fork(watchFetchSchoolBuses),
    fork(watchRemoveBus),
    fork(watchUpdateBus),
    fork(watchAddMonitorRoutes),
    fork(watchaddStudentParents),
    fork(watchRemoveStudentParents),
    fork(watchUpdateStudent),
    fork(watchNextTemporalBanner),
    fork(watchNewTemporalBanner),
    fork(watchStartTemporaryEvent),
    fork(watchUpdateParent),
    fork(watchParentFetch),
    fork(watchParentStudentsFetch),
    fork(watchFetchChangeStopRequestCounter),
    fork(watchSingleTripFetchStarted),
    fork(watchFinishTrip),
    fork(watchUpdateBusLastPosition),
    fork(watchTimeUpdatedBusOffline),
    fork(watchAssignStudentToStops),
  ]);
}

export default mainSaga;



// WEBPACK FOOTER //
// ./src/scripts/sagas/index.js